import App from './App';

import './styles/main.scss';
import GlobalSettings from '../../core/GlobalSettings';

import {getUrlParams} from '../../core/utils';

export function designer (settings = {}) {
	
	let options = {};

	if (settings.options) {
		options  = {...settings.options};
	}

	const urlParams = getUrlParams(window.location.search);

	// merge options from settings and from url params
	if (urlParams) {
		options = {...options, ...urlParams}; //merge urlParams into settings.options (NB: urlParams overwrites options)
	}

	settings.options = options;
	this.settings = settings;
	
	const me = document.querySelector('script[data-name="aam-designer"]');
	let bootstrap = false;
	this.handoverKey =  settings.handoverKey || settings.options.hkey;
	this.languageId =   settings.languageId || settings.options.languageId;

	const globalSetting = new GlobalSettings();

	// handoverkey handling 
	//globalSetting.handoverKeyByURL(this.handoverKey);
	globalSetting.handoverKeyByURL();

	if (me) {

		//extract handover key attribute in script tag if not define in settings
		if (!this.handoverKey) {
			this.handoverKey = me.getAttribute('data-handoverkey') || null;
		}


		//if we're bootstraping
		const bootstrapAttr = me.getAttribute('data-bootstrap');
		bootstrap = bootstrapAttr && bootstrapAttr.toLowerCase() === 'true';
	}

	this.rootElement = settings.el ? findRootElementByName() : findRootElementByDefault();

	// terminate designer if rootElement has not  been found
	if (!this.rootElement) {
		//root element is not found - cannot proceed
		const rootElementName = settings.el || '#amm-designer';
		handlerError(`Designer element ${rootElementName} doesn't exist`);
	}

	// extract handover key from  rootElement if not defined before
	if (!this.handoverKey)  {
		this.handoverKey = this.rootElement.getAttribute('data-handoverkey');
		// terminate designer if handover key has not  been found
		if (!this.handoverKey) {
			handlerError('Please provide handoverkey');
		}
	}

	const app = new App(this);

	if (bootstrap) {
		start();
	}

	function handlerError(error) {
		if (settings.callbacks && settings.callbacks.onError) {
			settings.callbacks.onError(error);
		}

		throw  new Error(error);
	}

	this.start = function() {

		// callback onload
		if(this.settings.callbacks && this.settings.callbacks.onLoad) {
			this.settings.callbacks.onLoad();
		}

		console.log('%cDesigner Started... ', 'font-family:Arial;font-size: 13px; color: orange');
		app.start();
	};

	this.hide = function() {
		this.rootElement.style.display = 'none';
	};

	this.show = function() {
		this.rootElement.style.display = 'block';
	};

	this.close = function() {
	};

	function findRootElementByName (name) {
		return document.querySelector(`#${name}`);
	}

	function findRootElementByDefault () {
		return document.querySelector('#aam-designer') || document.querySelector('.aam-designer-init');
	}

	return this;
}

//window.aam = aam;